import styled from 'styled-components'

export const HeaderWrapper = styled.header`
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: 12px 0;
  }
`

export const Nav = styled.nav`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: 0 16px;
    flex-direction: row;
    gap: 12px;
  }
`

export const LogoImage = styled.img`
  height: 5rem;
  object-fit: contain;
  @media (max-width: 890px) {
    height: 7.2rem;
  }
`

export const Logo = styled.div`
  a {
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.textPrimary};
    text-decoration: none;
  }
`

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    gap: 1rem;
  }
`

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 3.2rem;
  font-size: 1.6rem;
  padding:0.6rem 2.9rem;
  
  ${props => props.variant === 'primary' && `
    background-color: ${props.theme.colors.highlight};
    color: #000;
    border: none;
    background-image: linear-gradient(180deg, #FFEA00 62%, #FFEF43 97%);
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(254, 234, 0, 0.3);
    }
  `}
  
  ${props => props.variant === 'secondary' && `
    background-color: transparent;
  background-image: linear-gradient(180deg, #FFEA00 62%, #FFEF43 97%);
    color: ${props.theme.colors.textPrimary};
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
    }
  `}

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: 8px 16px;
    font-size: 14px;
    height: 36px;
  }
`

export const SelectButton = styled.select`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: ${props => props.theme.colors.textPrimary};
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23666' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.highlight};
    box-shadow: 0 0 0 4px rgba(254, 234, 0, 0.1);
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: 8px 16px;
    font-size: 14px;
    height: 36px;
    padding-right: 32px;
    background-position: right 12px center;
  }
`